import React from 'react'
import { anyOverLimit, flowTypeUsage, usageForCatalogFlowTypes } from './flowLimits'
import {
  FLOW_USAGE_FOOTNOTE,
  FLOW_USAGE_HEADING,
  flowUsageOverSummary,
  flowUsageValue
} from './layoutBuilderCopy'
import './layoutBuilder.css'

// Strip above an integration's flow cards: one pill per catalog flow type with its used / max
// count. Informational only — going over a limit is highlighted, never blocked. With `usedOnly`
// the strip lists just the flow types at least one flow uses, instead of every catalog type.
export default function FlowTypeUsage ({ flows, integrationType, usedOnly = false }) {
  const usage = usedOnly ? flowTypeUsage(flows, integrationType) : usageForCatalogFlowTypes(flows, integrationType)
  if (usage.length === 0) return null
  const overCount = usage.filter(item => item.over).length

  return (
    <section className='layoutBuilder-usage' aria-label={FLOW_USAGE_HEADING}>
      <div className='layoutBuilder-usage-header'>
        <h3>{FLOW_USAGE_HEADING}</h3>
        {anyOverLimit(usage) && <span className='layoutBuilder-usage-over-summary'>{flowUsageOverSummary(overCount)}</span>}
      </div>
      <ul className='layoutBuilder-usage-pills'>
        {usage.map(item => (
          <li
            key={item.flowTypeId}
            aria-label={item.name}
            className={`layoutBuilder-usage-pill${item.over ? ' is-over' : ''}${item.count === 0 ? ' is-empty' : ''}`}
          >
            {item.over && <i className='pi pi-exclamation-triangle' aria-hidden='true' />}
            <span className='layoutBuilder-usage-pill-name'>{item.name}</span>
            <strong>{flowUsageValue(item.count, item.max)}</strong>
          </li>
        ))}
      </ul>
      {overCount > 0 && <p className='layoutBuilder-usage-footnote'>{FLOW_USAGE_FOOTNOTE}</p>}
    </section>
  )
}
